var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFeedbackFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 170.667c0-94.257 76.41-170.667 170.667-170.667h682.667c94.255 0 170.667 76.41 170.667 170.667v682.667c0 94.255-76.412 170.667-170.667 170.667h-682.667c-94.257 0-170.667-76.412-170.667-170.667v-682.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M785.067 170.667h-546.133c-37.547 0-67.925 30.72-67.925 68.267l-0.341 614.4 136.533-136.533h477.867c37.547 0 68.267-30.72 68.267-68.267v-409.6c0-37.547-30.72-68.267-68.267-68.267zM785.067 648.533h-506.197l-39.936 39.936v-449.536h546.133v409.6zM477.867 512h68.267v68.267h-68.267v-68.267zM477.867 307.2h68.267v136.533h-68.267v-136.533z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedbackFilled);
export default __webpack_public_path__ + "static/media/icon-feedback-filled.db4257622a1c9b6df423fee7a3782fab.svg";
export { ForwardRef as ReactComponent };